import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';

const INITIAL_MATCHES = [
  {
    id: 1,
    name: 'Priya S.',
    age: 26,
    caste: 'Brahmin',
    gotra: 'Kasyap',
    education: 'B.E. Computer Science',
    occupation: 'Software Engineer',
    location: 'Kathmandu / Tansen',
    gender: 'Bride (Female)',
    kundali: 'Matched (32 Guna)',
    photoBlur: true
  },
  {
    id: 2,
    name: 'Arjun P.',
    age: 29,
    caste: 'Chhetri',
    gotra: 'Bharadwaj',
    education: 'MBA Finance',
    occupation: 'Banking Officer',
    location: 'Butwal, Rupandehi',
    gender: 'Groom (Male)',
    kundali: 'Matched (28 Guna)',
    photoBlur: false
  },
  {
    id: 3,
    name: 'Neha G.',
    age: 25,
    caste: 'Newar',
    gotra: 'Garga',
    education: 'MBBS Doctor',
    occupation: 'Medical Officer',
    location: 'Pokhara / Palpa',
    gender: 'Bride (Female)',
    kundali: 'Matched (30 Guna)',
    photoBlur: true
  }
];

export default function Matches() {
  const navigate = useNavigate();
  const [filterCaste, setFilterCaste] = useState('ALL');
  const [requestSent, setRequestSent] = useState({});

  const filteredMatches = filterCaste === 'ALL'
    ? INITIAL_MATCHES
    : INITIAL_MATCHES.filter((p) => p.caste.toUpperCase() === filterCaste.toUpperCase());

  const handleConnect = (id) => {
    setRequestSent((prev) => ({ ...prev, [id]: true }));
  };

  return (
    <div className="pi">
      <Navbar />

      <div className="sec-wrapper">
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <span className="badge-light">✦ Confidential Matchmaking Registry ✦</span>
          <h1 className="section-title">Initial Curated Matches (Limit: 3 Matches)</h1>
          <p style={{ color: '#6E615E', maxWidth: '650px', margin: '0.4rem auto 0', fontSize: '0.92rem' }}>
            Managed by <strong>Laxmikant Timilsina</strong> (Tansen-09, Palpa | 9857074103). Contact details remain protected until mutual consent.
          </p>
        </div>

        {/* Caste Filter Pills */}
        <div style={{
          display: 'flex',
          gap: '0.8rem',
          justifyContent: 'center',
          flexWrap: 'wrap',
          marginBottom: '2.5rem'
        }}>
          {['ALL', 'Brahmin', 'Chhetri', 'Newar'].map((caste) => (
            <button
              key={caste}
              onClick={() => setFilterCaste(caste)}
              className="btn btn-sm"
              style={{
                background: filterCaste === caste ? '#9E1B32' : '#FFFFFF',
                color: filterCaste === caste ? '#fff' : '#1C1014',
                border: '1.5px solid #E8DFD1',
                fontWeight: 700
              }}
            >
              {caste === 'ALL' ? '✦ All 3 Matches' : `${caste} Caste`}
            </button>
          ))}
        </div>

        {/* Matches Grid (3 Matches) */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(290px, 1fr))',
          gap: '2rem',
          marginBottom: '3.5rem'
        }}>
          {filteredMatches.map((p) => (
            <div key={p.id} className="card" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.8rem' }}>
                  <span className="badge-verified">✓ Verified Profile</span>
                  <span className="badge-light" style={{ background: '#FAF6ED', color: '#8C6A23' }}>
                    {p.kundali}
                  </span>
                </div>

                {/* Photo Placeholder */}
                <div style={{
                  height: '140px',
                  background: 'linear-gradient(135deg, #7A1221, #9E1B32)',
                  borderRadius: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  marginBottom: '1rem',
                  filter: p.photoBlur ? 'blur(1px)' : 'none'
                }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '2.5rem' }}>{p.gender.includes('Bride') ? '👰' : '🤵'}</div>
                    <div style={{ fontSize: '0.74rem', color: '#F7D070', fontWeight: 700, marginTop: '0.2rem' }}>
                      {p.photoBlur ? '🔒 Photo Privacy Protected' : 'Verified Photo'}
                    </div>
                  </div>
                </div>

                <h3 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#1C1014', margin: '0.2rem 0', fontFamily: 'var(--serif)' }}>
                  {p.name} ({p.age} Yrs)
                </h3>
                <div style={{ fontSize: '0.82rem', fontWeight: 700, color: '#8C6A23', marginBottom: '0.4rem' }}>
                  {p.caste} Caste · Gotra: {p.gotra}
                </div>
                <div style={{ fontSize: '0.84rem', color: '#6E615E', marginBottom: '0.8rem', lineHeight: 1.5 }}>
                  🎓 {p.education} <br />
                  💼 {p.occupation} <br />
                  📍 {p.location}
                </div>

                <div className="privacy-shield" style={{ fontSize: '0.74rem', padding: '0.5rem 0.8rem' }}>
                  🔒 Phone & full identity hidden until accepted
                </div>
              </div>

              <div style={{ marginTop: '1rem' }}>
                {requestSent[p.id] ? (
                  <div style={{ background: '#e8f5e9', color: '#2e7d32', padding: '0.6rem', borderRadius: '12px', textAlign: 'center', fontSize: '0.8rem', fontWeight: 700 }}>
                    ✓ Request Sent to Laxmikant Timilsina!
                  </div>
                ) : (
                  <button className="btn btn-primary btn-full" onClick={() => handleConnect(p.id)}>
                    Connect / Request Introduction →
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Upgrade / Additional Matches Banner */}
        <div className="card" style={{ background: 'linear-gradient(135deg, #1C1014 0%, #28171C 100%)', color: 'white', border: '1.5px solid #D4AF37', textAlign: 'center' }}>
          <span className="badge" style={{ background: 'rgba(212, 175, 55, 0.25)', color: '#F7D070', marginBottom: '0.6rem' }}>
            Need More Than 3 Matches?
          </span>
          <h2 style={{ fontFamily: 'var(--serif)', fontSize: '1.9rem', fontWeight: 700, color: '#F7D070', margin: '0.4rem 0' }}>
            Request Additional Match Recommendations
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.85)', maxWidth: '650px', margin: '0 auto 1.4rem', fontSize: '0.88rem' }}>
            Registered members receive <strong>3 curated matches</strong> initially. To receive additional match recommendations, pay an extra consultation fee to marriage consultant <strong>Laxmikant Timilsina (9857074103)</strong>.
          </p>
          <div style={{ display: 'flex', gap: '0.9rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button className="btn btn-secondary" onClick={() => navigate('/consultation/payment')}>
              📲 Pay Consultation Fee to Laxmikant (9857074103)
            </button>
            <a href="tel:9857074103" className="btn btn-tertiary">
              📞 Call Laxmikant (9857074103)
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
